import moment from 'moment';

const getConsultDate = (date) => moment(date).add(1, 'days').format('YYYY.MM.DD');

const getOtherConsultDate = (hour, min) => {
  if (hour > 17) {
    hour = '10';
    min = '00';
    date = getConsultDate(date);
  }

  if (hour === 17 && min !== '00') {
    date = getConsultDate(date);
    hour = '10';
    min = '00';
  }

  if (hour < 11) {
    if (hour < 10) {
      min = '00';
    }

    hour = '10';
  }

  return { hour, min };
}

const getDefaultConsultTime = (isException = false) => {
  const times = moment().format('HH:mm').split(':');
  let hour = times[0] * 1;
  let min = times[1] * 1;
  let date = moment().format('YYYY.MM.DD');

  if (min > 40 && min < 60) {
    hour = hour + 1;
    min = '00';
  }
  
  if (min > 0 && min < 20) {
    min = '20';
  }

  if (min > 20 && min < 40) {
    min = '40';
  }
  
  if (hour > 18) {
    hour = '09';
    min = '00';
    date = getConsultDate(date);
  }

  if (hour === 18 && min !== '00') {
    date = getConsultDate(date);
    hour = '09';
    min = '00';
  }

  if (hour < 10) {
    if (hour < 9) {
      min = '00';
    }

    hour = '09';
  }

  if (isException) {
    const exception = getOtherConsultDate(hour, min);
    console.log(exception)
    hour = exception.hour;
    min = exception.min;
  }

  return {
    time: hour + ':' + min,
    date
  }
}

export default {
  install(Vue) {
    Vue.prototype.$getDefaultConsultTime = getDefaultConsultTime;
  }
}